import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { CreateTemporaryLicensesInput, CreateTemporaryLicensesPayload } from './generated/types';
import { GqlError } from './GqlError';

const mutation = `mutation CreateTemporaryLicenses($input: CreateTemporaryLicensesInput!) {
    createTemporaryLicenses(input: $input) {
        licenseSystemId
        succeeded
    }
}`;

export const useCreateTemporaryLicenses = (orgId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (licenseSystemId: string) => {

            const input: CreateTemporaryLicensesInput = {
                licenseSystemId,
                orgId,
            };

            const { data } = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    createTemporaryLicenses: CreateTemporaryLicensesPayload;
                };
                errors?: Array<GqlError>;
            }>);

            const isSucceeded = !!data.createTemporaryLicenses.succeeded;

            return isSucceeded;
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['getOrganization', orgId] });
        },
    });
};